/**
 * The trailer the queue modal plays.
 *
 * Two pages open the same modal — the signed-out screen and the dashboard —
 * so the id lives here rather than being typed twice.
 */
export const TRAILER_ID = 'qcdc7O4tsjs';
